module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('li', {
    staticClass: "dropdown"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "role": "menu"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/org/controlo1",
      "tag": "li"
    }
  }, [_c('a', [_vm._v("Controlo 1")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/org/controlo2",
      "tag": "li"
    }
  }, [_c('a', [_vm._v("Controlo 2")])])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-expanded": "false"
    }
  }, [_vm._v("Controlos "), _c('span', {
    staticClass: "caret"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-585e0fae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/org/Nav.vue
// module id = 262
// module chunks = 1